export const GmbActionType = {
  ADD: 1,
  DELETE: 2,
  SET: 3
};
